import styled from '@emotion/styled'
import { Image, Props as ImageProps } from 'app/components/Common/Image'
import React, { memo } from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'
import { Parallax } from 'react-scroll-parallax'

export interface Props {
  image: ImageProps
}

export const Visual = memo(function Visual({ image }: Props) {
  if (!image) {
    return null
  }

  return (
    <Container>
      {image ? (
        <LazyLoadComponent>
          <Parallax scale={[1, 1.2]}>
            <Image {...image} />
          </Parallax>
        </LazyLoadComponent>
      ) : null}
    </Container>
  )
})

const Container = styled.section`
  height: 88.9vh;
  max-height: 50rem;
  margin-top: 4.625rem;
  overflow: hidden;

  > div {
    width: 100%;
    height: 100%;
    position: relative;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (max-width: 1199px) {
    aspect-ratio: 1.33;
    height: auto;
    max-height: none;
    margin-top: 3.75rem;
  }
`
